module.exports = __webpack_public_path__ + "img/2620.459e176.svg";